import { useCallbackEvent } from '@dni-react-hooks/use-callback-event'
import { parseToNumber } from '@utils/parseToNumber'
import { type ButlerItem } from '../../types'
import { cartStoreMap, type PlatformType } from './store-map'

export const useFpB2bButlerItemsService = (campaignId: number | null, platform: PlatformType) => {
  const { useCartStore, cartDefaultValues } = cartStoreMap[platform]
  const [cartValues, setCartValues] = useCartStore(campaignId)

  const upsertButlerItem = useCallbackEvent((nextItem: ButlerItem) => {
    const { prevState, nextState } = setCartValues((state) => {
      const { butler } = state
      const { items } = butler
      const nextItems = [...items]

      const findIndex = nextItems.findIndex(item => item.cartItemId === nextItem.cartItemId)

      if (findIndex === -1) {
        nextItems.push(nextItem)
      }
      else {
        if (!nextItems[findIndex]) return state
        const updatedItem = {
          ...nextItems[findIndex],
          ...nextItem,
        }

        // 缺貨商品不能進提交範圍，更新後超過庫存就強制取消勾選
        const stock = Math.max(parseToNumber(updatedItem?.stock), 0)
        const outOfStock = updatedItem.quantity && updatedItem.quantity > stock
        if (outOfStock) {
          updatedItem.checked = false
        }

        nextItems[findIndex] = updatedItem
      }

      return {
        ...state,
        butler: {
          ...butler,
          items: nextItems,
        },
      }
    })

    return {
      prevState: prevState?.butler.items,
      nextState: nextState?.butler.items,
    }
  })

  const deleteAllButlerItems = useCallbackEvent(() => {
    setCartValues((state) => {
      return {
        ...state,
        butler: {
          ...state.butler,
          items: [],
        },
      }
    })
  })

  const setFileName = useCallbackEvent((fileName: string) => {
    setCartValues((state) => {
      return {
        ...state,
        butler: {
          ...state.butler,
          fileName,
        },
      }
    })
  })

  const resetButler = useCallbackEvent(() => {
    setCartValues((state) => {
      return {
        ...state,
        butler: cartDefaultValues.butler,
      }
    })
  })

  return {
    ...cartValues.butler,
    upsertButlerItem,
    deleteAllButlerItems,
    setFileName,
    resetButler,
  }
}
